export const COMMON_INGREDIENTS = {
  "Proteins": [
    "Chicken breast",
    "Ground beef",
    "Salmon",
    "Eggs",
    "Tofu",
    "Shrimp",
    "Pork chops"
  ],
  "Vegetables": [
    "Onion",
    "Garlic",
    "Tomatoes",
    "Bell peppers",
    "Carrots",
    "Broccoli",
    "Spinach",
    "Potatoes"
  ],
  "Grains & Pasta": [
    "Rice",
    "Pasta",
    "Quinoa",
    "Bread crumbs",
    "Flour"
  ],
  "Dairy": [
    "Milk",
    "Cheese",
    "Butter",
    "Heavy cream",
    "Yogurt"
  ],
  "Herbs & Spices": [
    "Salt",
    "Black pepper",
    "Oregano",
    "Basil",
    "Thyme",
    "Cumin",
    "Paprika",
    "Cinnamon"
  ],
  "Condiments": [
    "Olive oil",
    "Soy sauce",
    "Vinegar",
    "Honey",
    "Mustard",
    "Mayonnaise"
  ]
};